import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShieldAlert } from "lucide-react";
import { Btn } from "./ui";

export default function RedAlertBar({ active, onLift }) {
  return (
    <AnimatePresence>
      {active && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="w-full overflow-hidden bg-aegis-red"
          data-testid="red-alert-bar"
        >
          <div className="flex items-center justify-between gap-4 px-6 py-2.5">
            <div className="flex items-center gap-3 text-slate-100 min-w-0">
              <ShieldAlert size={18} className="animate-pulseGlow shrink-0" />
              <span className="text-xs sm:text-[13px] font-semibold tracking-wide truncate">
                CRITICAL LOCKDOWN ACTIVE — 零信任网格已进入紧急隔离状态，所有外部写动作强制冻结
              </span>
            </div>
            <Btn
              variant="ghost"
              testid="lift-lockdown-btn"
              onClick={onLift}
              className="!border-white/40 !text-slate-100 hover:!bg-white/15 !py-1.5 shrink-0"
            >
              解除熔断隔离 · Lift Lockdown
            </Btn>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
